export const selectPropertyBookingMessagesContent =
  ({ hotelCode, bookingStep }) =>
  (state) =>
    state.bookingMessages?.data[bookingStep][hotelCode] || {};
